// extracted by mini-css-extract-plugin
module.exports = {"footerWrap":"style_footerWrap__1kMPj","links":"style_links__xIC8a","infos":"style_infos__1HBlX"};